import React, { useEffect } from "react";

const RedirectToUrl = (props: any) => {
    useEffect(() => {
        const query = new URLSearchParams(props.location.search);
        const pageName = query.get("pageName");
        if (pageName != null && pageName === "credit") {
            const tabName = query.get("tabName");
            props.history.push("/credit/" + tabName);
        } else {
            props.history.push("/dashboard");
        }
    }, []);

    return <React.Fragment></React.Fragment>;
};

export default RedirectToUrl;
